"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectWrapper = exports.SearchFilterWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const elements_1 = require("@src/components/elements");
const styled_breakpoints_1 = require("styled-breakpoints");
exports.SearchFilterWrapper = styled_components_1.default.div `
	display: flex;
	width: 100%;
	min-height: 3rem;
	margin-bottom: ${({ isTagCountInLimit }) => (isTagCountInLimit ? '1rem' : '0.5rem')};
	.ant-select-focused {
		z-index: 1;
	}

	.ant-select:hover {
		z-index: 1;
	}

	${(0, styled_breakpoints_1.down)('md')} {
		flex-direction: column;
	}
`;
exports.SelectWrapper = (0, styled_components_1.default)(elements_1.Select) `
	width: 100%;

	.ant-select-selection-search {
		max-width: 100%;
	}
`;
